import { Link, useNavigate, useLocation } from 'react-router-dom'

// Minimal pre-launch header: logo + Features + a single "join the waitlist" CTA.
// No nav into the rest of the (unlaunched) site.
export default function LaunchHeader() {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  // Already on the waitlist page → smooth-scroll to exactly where the form starts
  // (offset for this floating header). Elsewhere → go to /waitlist#join, which the
  // page reads on mount to scroll to the same spot.
  function joinClick(e) {
    if (pathname !== '/waitlist') return // let the Link navigate to /waitlist#join
    e.preventDefault()
    const el = document.getElementById('join')
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 88, behavior:'smooth' })
  }

  return (
    <>
      <header style={{
        position:'fixed', top:16, left:'50%', transform:'translateX(-50%)',
        width:'calc(100% - 32px)', maxWidth:1000,
        background:'rgba(250,250,248,0.92)', backdropFilter:'blur(14px) saturate(1.6)',
        border:'1px solid rgba(229,224,216,0.6)', borderRadius:100,
        boxShadow:'0 4px 22px rgba(0,0,0,0.05)', padding:'0.55rem 0.9rem 0.55rem 1.25rem',
        display:'flex', alignItems:'center', justifyContent:'space-between', zIndex:100,
      }}>
        <Link to="/waitlist" style={{ flexShrink:0, display:'flex' }}>
          <img src="/okoiya-logo.png" alt="Okoiya" style={{ height:28, objectFit:'contain', display:'block' }}/>
        </Link>
        <div style={{ display:'flex', alignItems:'center', gap:'1.1rem' }}>
          <Link to="/features" style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.85rem', fontWeight:600, color:'#6B6B6B', textDecoration:'none' }}>Features</Link>
          <Link to="/waitlist#join" onClick={joinClick} style={{ textDecoration:'none' }}>
            <button style={{ fontFamily:'Nunito Sans, sans-serif', fontWeight:700, fontSize:'0.8rem', color:'white', background:'#C4826A', border:'none', borderRadius:100, padding:'0.55rem 1.1rem', cursor:'pointer' }}
              onMouseEnter={e=>e.currentTarget.style.background='#B36B55'}
              onMouseLeave={e=>e.currentTarget.style.background='#C4826A'}>
              Join the waitlist
            </button>
          </Link>
        </div>
      </header>
      <div style={{ height:68 }}/>
    </>
  )
}
